<div class="axis-content-wrapper">
  <div class="axis-container-fluid">
    <div>
      <img
        alt="AIG logo"
        class="aig-logo"
        src="assets/images/logos/aig-logo-blue.svg"
      />
      <span class="_sr-only">American International Group, Inc.</span>
    </div>
    <div class="initial-empty-container">
      <img
        alt=""
        class="axis-img-responsive _mlr-auto"
        src="assets/images/messages/503.svg"
        loading="lazy"
      />
      <div
        class="axis-title"
        role="heading"
        aria-level="1"
      >
       <h1>System Under Maintenance</h1>
      </div>
        <p >
          We're currently performing scheduled maintenance to improve your experience.
          Please check back later.
        </p>
    </div>
  </div>
</div>
